var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-container"},[_c('img',{class:_vm.schema.class,attrs:{"src":_vm.imageURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }